var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReverse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3404 33.589C26.42 33.589 33.7804 26.2285 33.7804 17.149C33.7804 8.06943 26.42 0.708984 17.3404 0.708984C8.26083 0.708984 0.900391 8.06943 0.900391 17.149C0.900391 26.2285 8.26083 33.589 17.3404 33.589Z",
    fill: "#E6E8EC",
    stroke: "#BFBFBF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08984 16.9391V13.3091H21.9998L19.7798 9.47913L22.8098 7.86914L29.3598 16.9391H9.08984Z",
    fill: "#2B1A81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9299 18.7598V22.3898H13.03L15.2499 26.2197L12.2199 27.8298L5.66992 18.7598H25.9299Z",
    fill: "#2B1A81"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/reverse.190ed924551b032a529e4a1101bec20c.svg";
export { ForwardRef as ReactComponent };